<template>
  <div class="kye-report-dgkp001" @click="handleClick('cardClick')">
    <div class="dgkp001_main-cell-empty1"></div>
    <div
      class="dgkp001_main-cell-icon"
    >
      <img
        class="dgkp001_main-icon1"
        :src="data.mainIcon1 || mainIcon1"
        @click="handleClick('mainIcon1')"
        v-events="{ eventsMap,  ignoreEventName, args: ['mainIcon1', data.mainIcon1]}"
      />
    </div>
    <div class="dgkp001_main-cell-right">
      <div class="dgkp001_main-cell-title">
        <div
          @click="handleClick('mainTitle')"
          v-events="{ eventsMap,  ignoreEventName, args: ['mainTitle', data.mainTitle]}"
        >{{ data.mainTitle }}</div>
        <KyeReportCardQuestion
          class="dgkp001_main-icon2"
          :icon="data.mainIcon2"
          :popover="data.popover"
          @click="handleClick('mainIcon2')">
          <slot :name="'tooltip'"></slot>
      </KyeReportCardQuestion>
      </div>
      <div class="dgkp001_main-cell-index" @click="handleClick('mainIndex')">
        <div
          class="main-index"
          v-events="{ eventsMap, args: ['mainIndex', data.mainIndex]}"
        >{{ data.mainIndex }}</div>
        <div
          class="dgkp001_main-index-unit"
          v-events="{ eventsMap, args: ['mainIndexUnit', data.mainIndex]}"
        >{{ data.mainIndexUnit }}</div>
      </div>
    </div>
    <div class="dgkp001_main-cell-empty2"></div>
    <card-popover
      :popoverConfig="popoverConfig"
    >
      <slot :name="cardPopoverSlotName"></slot>
    </card-popover>
  </div>
</template>
<script>
import mainIcon1 from '../../asset/images/dgkp001.png'
import KyeReportCardQuestion from '../common/question.vue'
export default {
  name: 'KyeReportDgkp001',
  components: {
    KyeReportCardQuestion
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      mainIcon1
    }
  },
  mounted() {
  },
  methods: {
    handleClick(eventName) {
      this.$emit(eventName, this.data)
    }
  }
}
</script>
<style lang="scss">
@import '../../style/extend.scss';
.kye-report-dgkp001 {
  background: #FFFFFF;
  border-radius: 4px;
  padding: 16px 0;
  flex-direction: row;
  cursor: pointer;
  gap: 16px;
  display: flex;
  .dgkp001_main-cell-icon {
    .dgkp001_main-icon1 {
      width: 58px;
      height: 58px;
    }
  }
  .dgkp001_main-cell-right {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .dgkp001_main-cell-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: #666666;
      font-size: 14px;
      .dgkp001_main-icon2 {
        margin-left: 4px;
      }
    }
    .dgkp001_main-cell-index {
      display: flex;
      flex-direction: row;
      font-size: 24px;
      line-height: 24px;
      color: #333333;
      font-weight: 600;
      .dgkp001_main-index-unit {
        font-size: 14px;
        line-height: 14px;
        display: flex;
        flex-direction: column-reverse;
        margin-left: 2px;
      }
    }
  }
  .dgkp001_main-cell-empty1 {
    flex: 1;
  }
  .dgkp001_main-cell-empty2 {
    flex: 2;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/card/dgkp001/index.vue